import React, { useEffect, useRef, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Button from '../../../components/elements/button';
import toast from 'react-hot-toast';
import Icon from '../../../components/icons';
import Textarea from '../../../components/elements/form/textarea';
import { statusChangeDataType } from '../../../_common/types';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    data: statusChangeDataType
    onUpdate?: () => void
    onCancel?: () => void
}



const StatusChangeReasonModal: React.FC<Props> = ({ _ref, data, onUpdate = () => { }, onCancel = () => { } }) => {

    const assetsApi = useAssetsApi();

    const [working, setWorking] = useState<boolean>(false);

    const { control, reset, handleSubmit, formState: { errors } } = useForm<any>();
    const onSubmit = (formData: any) => {
        setWorking(true);
        assetsApi.updateStatus({
            "assetID": data?.assetID,
            "assetStatusID": data?.status.id
        }, (resp: any) => {
            setWorking(false)
            toast.success('Status updated successfully');
            onUpdate();
            onClose();
        }, (err: any) => {
            setWorking(false)
            toast.error('Failed to update status');
        })
    }

    const onClose = () => {
        _ref?.current?.close();
        reset({
            reason: ''
        });
        onCancel();
    }

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[30rem] p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>Change Status</p>
                        <button onClick={onClose} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3'>

                        <Controller
                            name='reason'
                            control={control}
                            rules={{ required: 'Reason required' }}
                            render={({ field: { value, onChange } }) => (
                                <Textarea
                                    label='Reason'
                                    value={value}
                                    onChange={onChange}
                                    placeholder='Reason...'
                                    error={errors?.reason?.message as any}
                                />
                            )}
                        />
                    </div>

                    <div className='flex justify-end gap-2 border-t border-[#8D6E63] pt-2'>
                        <Button type="button" theme='secondary' onClick={() => {
                            _ref?.current?.close();
                            onClose();
                        }}>Cancel</Button>
                        <Button type="submit" working={working} >Save</Button>
                    </div>

                </form>

            </div>
            <form method="dialog" className="modal-backdrop" onClick={onClose}>

            </form>
        </dialog>
    );
};

export default StatusChangeReasonModal;